import type {
  RadioChangeEvent,
  RadioGroupProps as AntRadioGroupProps
} from 'antd';
import { Radio as AntRadio } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme/semanticTokens';
import { RadioButton, RadioButtonProps } from '../RadioButton/RadioButton';

export interface RadioGroupProps extends Omit<AntRadioGroupProps, 'options'> {
  options?: Array<RadioButtonProps>;
  onChange?: (value: RadioChangeEvent) => void;
}

const StyledRadioGroup = styled(AntRadio.Group)`
  display: flex;
  flex-direction: row;
  gap: ${theme.dime.spacing.m};
`;

export const RadioGroup = React.forwardRef<HTMLDivElement, RadioGroupProps>(
  ({ options, children, onChange, ...props }, ref) => {
    return (
      <StyledRadioGroup ref={ref} onChange={onChange} {...props}>
        {options?.map((option) => (
          <RadioButton {...option} key={option.value} />
        )) || children}
      </StyledRadioGroup>
    );
  }
);

RadioGroup.displayName = 'RadioGroup';
